import { css } from "@emotion/react";

export const MGameFavouriteCardStyle = {
  self: css`
    max-width: 92.5px;
    width: 100%;
  `,

  imageWrapper: css`
    width: 100%;
    aspect-ratio: 1/1;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,

  provider: css`
    position: absolute;
    top: 0;
    right: 0px;
    min-width: 20px;
    padding: 0 2px;
    height: 13px;
    color: #000;
    font-size: 12px;
    text-align: center;
    border-radius: 3px;
    box-shadow: 0 2px 4px #0006;
    border: 1px solid #ffd13b;
    background-image: linear-gradient(to bottom, #ffffc7, #ffd13b);
  `,

  btnHeart: css`
    width: 20px;
    height: 20px;
    background-color: #d00 !important;
    border-radius: 50%;
    position: absolute;
    right: -2px;
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  heartIcon: css`
    fill: #fff !important;
    width: 12px;
    height: 12px;
  `,

  name: css`
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: rgb(128 128 128 / 1);
  `,
};
